import React from 'react';
import Image from '../../../common/Image';
import StarIcon from '~images/loggedout/shapes/star.svg';

const ModularSection0 = () => {

  const tempDataArr = [
  {
    "heading":  "Loved by over",
    "countText": "40 million learners"
  },{
    "heading":  "Preferred learning solution in every",
    "countText": "1 in 3 US schools"
  },{
    "heading":  "80% learners show",
    "countText": "increased confidence in 4 weeks"
  }];

  return (
    <div className="clearfix modular-section-0-wrapper">
      <p className="head-text">
        Join millions of confident learners
      </p>

      <ul className="section-0-ul-list">
        {tempDataArr.map(function(individualData) {
          return(
            <li className="section-0-li-list-item">
              <span className="section-0-span">{individualData.heading}</span>
              <p className="section-0-p">{individualData.countText}</p>
            </li>
          )
        })}
      </ul>
      <Image src={StarIcon} alt="Blue star" className="section-0-img" />
    </div>
  );
};

export default ModularSection0;
